import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import addDays from 'date-fns/addDays';
import differenceInDays from 'date-fns/differenceInDays';
import decodeLocation from './utilities/decodeLocation';
import getQueryFromLocation from './utilities/getQueryFromLocation';
import {
  getInitialValuesFromLocalStorage,
  getInitialValuesFromURL,
} from './utilities/getInitialValues';
import { AGE_DEFAULT, AGE_OLD, AGE_YOUNGSTER } from './consts';

const AGE_OPTIONS = [AGE_YOUNGSTER, AGE_DEFAULT, AGE_OLD];

const resolveInitialValues = (queryParams) => {
  const initialValuesFromUrl = getInitialValuesFromURL(queryParams);

  if (!_isEmpty(initialValuesFromUrl)) {
    return initialValuesFromUrl;
  }

  const initialValuesFromLocalStorage = getInitialValuesFromLocalStorage();

  if (!_isEmpty(initialValuesFromLocalStorage)) {
    return initialValuesFromLocalStorage;
  }

  const defaultAgeOption = AGE_OPTIONS[1];

  return {
    pickUp: '',
    dropOff: '',
    age: defaultAgeOption,
    pickUpDate: { startDate: addDays(new Date(), 3) }, // NOTE: Кол-во дней согласовано с PM.
    dropOffDate: { startDate: addDays(new Date(), 9) }, // Отталкиваемся от статистики поиска
    pickUpTime: '12:00',
    dropOffTime: '12:00',
  };
};

const decodeQuery = ({
  pKey: queryPKey,
  dKey: queryDKey,
  pLocation,
  dLocation,
  ...queryParams
}) => {
  const { name: pName, key: pKey = queryPKey } = (pLocation && decodeLocation(pLocation)) || {};

  const { name: dName, key: dKey = queryDKey } = (dLocation && decodeLocation(dLocation)) || {};

  return {
    ...queryParams,
    pKey,
    dKey,
    pLocation: { name: pName, key: pKey },
    dLocation: { name: dName, key: dKey },
  };
};

const isBeforeNow = (date) => differenceInDays(date, new Date()) < 0;

const getActualInitialDates = (pickUpDate, dropOffDate) => {
  const { startDate: pStartDate } = pickUpDate;
  const { startDate: dStartDate } = dropOffDate;

  if (!pStartDate || !dStartDate) {
    return {};
  }

  if (isBeforeNow(pStartDate) || isBeforeNow(dStartDate)) {
    return {
      pickUpDate: { startDate: addDays(new Date(), 3) },
      dropOffDate: { startDate: addDays(new Date(), 9) },
    };
  }

  return {
    pickUpDate,
    dropOffDate,
  };
};

export default (Component) => (props) => {
  const { location = window.location } = props;
  const queryParams = getQueryFromLocation(location);
  const initialValues = resolveInitialValues(queryParams);
  const { pickUpDate, dropOffDate } = initialValues;

  return (
    <Component
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      initialValues={{ ...initialValues, ...getActualInitialDates(pickUpDate, dropOffDate) }}
      initialQueryParams={decodeQuery(queryParams)}
    />
  );
};
